"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,16.6c-0.1,0-0.2,0-0.3-0.1l-3-2C9.1,14.4,9,14.2,9,14.1v-3.2c0-0.2,0.1-0.3,0.2-0.4l3-2c0.2-0.1,0.4-0.1,0.6,0l3,2 c0.1,0.1,0.2,0.2,0.2,0.4v3.2c0,0.2-0.1,0.3-0.2,0.4l-3,2C12.7,16.5,12.6,16.6,12.5,16.6z M10,13.8l2.5,1.6l2.5-1.6v-2.6 l-2.5-1.6L10,11.2V13.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,6.5c-0.1,0-0.2,0-0.3-0.1l-1.6-1c-0.2-0.1-0.3-0.4-0.2-0.7s0.5-0.3,0.7-0.2l1.4,0.8l1.4-0.8 c0.2-0.1,0.5-0.1,0.7,0.2c0.1,0.2,0.1,0.5-0.2,0.7l-1.7,1C12.7,6.5,12.6,6.5,12.5,6.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,9.5C12.2,9.5,12,9.2,12,9V4.4c0-0.3,0.2-0.5,0.5-0.5S13,4.1,13,4.4V9C13,9.2,12.8,9.5,12.5,9.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,8.5c-0.1,0-0.2,0-0.3-0.1l-1.6-1c-0.2-0.1-0.3-0.4-0.2-0.7s0.5-0.3,0.7-0.2l1.4,0.8l1.4-0.8 c0.2-0.1,0.5-0.1,0.7,0.2c0.1,0.2,0.1,0.5-0.2,0.7l-1.7,1C12.7,8.5,12.6,8.5,12.5,8.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,21.1c-0.3,0-0.5-0.2-0.5-0.5V16c0-0.3,0.2-0.5,0.5-0.5S13,15.8,13,16v4.6C13,20.9,12.8,21.1,12.5,21.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M14.1,20.5c-0.1,0-0.2,0-0.3-0.1l-1.4-0.8l-1.4,0.8c-0.2,0.1-0.5,0.1-0.7-0.2c-0.1-0.2-0.1-0.5,0.2-0.7l1.6-1 c0.2-0.1,0.4-0.1,0.5,0l1.7,1c0.2,0.1,0.3,0.5,0.2,0.7C14.5,20.4,14.3,20.5,14.1,20.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M14.1,18.5c-0.1,0-0.2,0-0.3-0.1l-1.4-0.8l-1.4,0.8c-0.2,0.1-0.5,0.1-0.7-0.2c-0.1-0.2-0.1-0.5,0.2-0.7l1.6-1 c0.2-0.1,0.4-0.1,0.5,0l1.7,1c0.2,0.1,0.3,0.5,0.2,0.7C14.5,18.4,14.3,18.5,14.1,18.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M5.5,16.7c-0.2,0-0.4-0.1-0.4-0.3c-0.1-0.2,0-0.5,0.2-0.7l4.1-2.2c0.2-0.1,0.5,0,0.7,0.2c0.1,0.2,0,0.5-0.2,0.7 l-4.1,2.2C5.6,16.7,5.6,16.7,5.5,16.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M6.8,17.9C6.8,17.9,6.8,17.9,6.8,17.9c-0.3,0-0.5-0.3-0.5-0.5l0.1-1.6L5,14.9c-0.2-0.1-0.3-0.4-0.2-0.7 C5,14,5.3,13.9,5.5,14l1.7,1c0.2,0.1,0.3,0.3,0.2,0.5l-0.1,1.9C7.3,17.7,7.1,17.9,6.8,17.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M8.6,16.9C8.6,16.9,8.5,16.9,8.6,16.9c-0.3,0-0.5-0.3-0.5-0.5l0.1-1.6L6.8,14c-0.2-0.1-0.3-0.4-0.2-0.7S7,13,7.3,13.1 l1.7,1c0.2,0.1,0.3,0.3,0.2,0.5l-0.1,1.9C9,16.7,8.8,16.9,8.6,16.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M9.5,11.5c-0.1,0-0.2,0-0.2-0.1L5.2,9.2C5,9.1,4.9,8.8,5,8.5c0.1-0.2,0.4-0.3,0.7-0.2l4.1,2.2c0.2,0.1,0.3,0.4,0.2,0.7 C9.9,11.4,9.7,11.5,9.5,11.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M5.3,11.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.7l1.4-0.8L6.3,7.7c0-0.3,0.2-0.5,0.5-0.5 c0.3,0,0.5,0.2,0.5,0.5l0.1,1.9c0,0.2-0.1,0.4-0.2,0.5l-1.7,1C5.5,11,5.4,11.1,5.3,11.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M7,12c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.7l1.4-0.8L8.1,8.6c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5 l0.1,1.9c0,0.2-0.1,0.4-0.2,0.5l-1.7,1C7.2,12,7.1,12,7,12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M19.5,16.7c-0.1,0-0.2,0-0.2-0.1l-4.1-2.2c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2l4.1,2.2 c0.2,0.1,0.3,0.4,0.2,0.7C19.9,16.6,19.7,16.7,19.5,16.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M18.2,17.9c-0.3,0-0.5-0.2-0.5-0.5l-0.1-1.9c0-0.2,0.1-0.4,0.2-0.5l1.7-1c0.2-0.1,0.5-0.1,0.7,0.2 c0.1,0.2,0.1,0.5-0.2,0.7l-1.4,0.8l0.1,1.6C18.7,17.6,18.5,17.9,18.2,17.9C18.2,17.9,18.2,17.9,18.2,17.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M16.4,16.9c-0.3,0-0.5-0.2-0.5-0.5l-0.1-1.9c0-0.2,0.1-0.4,0.2-0.5l1.7-1c0.2-0.1,0.5-0.1,0.7,0.2s0.1,0.5-0.2,0.7 l-1.4,0.8l0.1,1.6C16.9,16.7,16.7,16.9,16.4,16.9C16.5,16.9,16.4,16.9,16.4,16.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M15.5,11.5c-0.2,0-0.4-0.1-0.4-0.3c-0.1-0.2,0-0.5,0.2-0.7l4.1-2.2c0.2-0.1,0.5,0,0.7,0.2c0.1,0.2,0,0.5-0.2,0.7 l-4.1,2.2C15.6,11.4,15.5,11.5,15.5,11.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M19.7,11.1c-0.1,0-0.2,0-0.3-0.1l-1.7-1c-0.2-0.1-0.3-0.3-0.2-0.5l0.1-1.9c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.3,0.5,0.5 l-0.1,1.6l1.4,0.8c0.2,0.1,0.3,0.4,0.2,0.7C20,11,19.9,11.1,19.7,11.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M18,12c-0.1,0-0.2,0-0.3-0.1l-1.7-1c-0.2-0.1-0.3-0.3-0.2-0.5l0.1-1.9c0-0.3,0.3-0.5,0.5-0.5c0.3,0,0.5,0.3,0.5,0.5 l-0.1,1.6l1.4,0.8c0.2,0.1,0.3,0.4,0.2,0.7C18.3,11.9,18.1,12,18,12z"
  }));
};

exports["default"] = _default;